import React from "react";
export var FinanceNoteInput = /*#__PURE__*/ React.forwardRef(function BaseFinanceNoteInput(param, ref) {
    var name = param.name, onChange = param.onChange;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h5", null, "Add a note for finance"), /*#__PURE__*/ React.createElement("textarea", {
        className: "short",
        id: "finance-note",
        "data-testid": "finance-note-input",
        name: name,
        onChange: onChange,
        ref: ref,
        placeholder: "e.g. a specific person to send the invoice to"
    }));
});
